import useFeatureFlag from 'src/components/feature-flags/useFeatureFlag';
import { isAdminImpersonating } from 'src/utils/impersonation';

/**
 * True when billing changes are paused via the `disable-signup` flag during a
 * payment-provider migration. Admins impersonating a user are exempt so support
 * keeps full control.
 */
export default function useIsBillingPaused(): boolean {
  const signupDisabled = useFeatureFlag('disable-signup');
  return Boolean(signupDisabled) && !isAdminImpersonating();
}
